/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DebtRequest } from './DebtRequest';
import {
    DebtRequestFromJSON,
    DebtRequestFromJSONTyped,
    DebtRequestToJSON,
    DebtRequestToJSONTyped,
} from './DebtRequest';

/**
 * 
 * @export
 * @interface UpdateClientDebtsRequest
 */
export interface UpdateClientDebtsRequest {
    /**
     * 
     * @type {Array<DebtRequest>}
     * @memberof UpdateClientDebtsRequest
     */
    debts: Array<DebtRequest>;
}

/**
 * Check if a given object implements the UpdateClientDebtsRequest interface.
 */
export function instanceOfUpdateClientDebtsRequest(value: object): value is UpdateClientDebtsRequest {
    if (!('debts' in value) || value['debts'] === undefined) return false;
    return true;
}

export function UpdateClientDebtsRequestFromJSON(json: any): UpdateClientDebtsRequest {
    return UpdateClientDebtsRequestFromJSONTyped(json, false);
}

export function UpdateClientDebtsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientDebtsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'debts': ((json['debts'] as Array<any>).map(DebtRequestFromJSON)),
    };
}

export function UpdateClientDebtsRequestToJSON(json: any): UpdateClientDebtsRequest {
    return UpdateClientDebtsRequestToJSONTyped(json, false);
}

export function UpdateClientDebtsRequestToJSONTyped(value?: UpdateClientDebtsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'debts': ((value['debts'] as Array<any>).map(DebtRequestToJSON)),
    };
}

